/**
 * Game Constants for Helix 2000
 * Centralized location for magic numbers, offsets, and physical constants.
 */

import { GameConstants as SharedConstants } from '../../shared/GameConstants';

/**
 * Game Constants Proxy for Helix 2000
 * Centralized proxy that redirects to the shared source of truth.
 */
export const GAME_CONSTANTS = {
  // Chat bubble settings moved to `src/shared/config/chat-bubble.config.ts`
  // (canonical defaults+dev-override pattern). Import `CHAT_BUBBLE` from
  // there directly — do not re-add proxy fields here.
  get UI() {
    return {
      MAP_DISPLAY_Y: SharedConstants.UI.DISPLAY.MAP_NAME_Y,
      NPC_TEXT_OFFSET_Y: SharedConstants.UI.DISPLAY.NPC_TEXT_OFFSET_Y,
    };
  },
  get PHYSICS() {
    return {
      GROUND_SNAP_OFFSET_Y: -40,
      GROUND_SNAP_BUFFER: 20,
      STANDING_HEIGHT_BUFFER: 40,
      DEFAULT_SPAWN_PADDING_X: 30,
      DEFAULT_MOB_SPAWN_Y_OFFSET: -60,
      MAX_PLATFORM_SEARCH_DISTANCE: 500,
      TELEPORTER_SNAP_RANGE: 1000,
      JUMP_FORCE: SharedConstants.Physics.GRAVITY,
    };
  },
  get NPC() {
    return {
      DEFAULT_WIDTH: SharedConstants.NPC.DIMENSIONS.DEFAULT_WIDTH,
      DEFAULT_HEIGHT: SharedConstants.NPC.DIMENSIONS.DEFAULT_HEIGHT,
      RESPAWN_DELAY_MS: SharedConstants.NPC.TIMING.RESPAWN_DELAY_MS,
    };
  },
  DEBUG: {
    SPAWN_DELAY_MS: 2000,
    TELEMETRY_FRAMES: 30,
    FORCE_TEXTURE_REFRESH_DELAY: 2000,
  },
  get DEFAULTS() {
    return {
      // Delegate to the shared SSOT (was a hardcoded 'multiplayer-observe' that
      // diverged from shared 'pig-testring' — collapsed to one canonical
      // 'starter-map' on 2026-06-05). See SharedConstants.Defaults.MAP.
      MAP: SharedConstants.Defaults.MAP,
      SPAWN_POS: SharedConstants.Defaults.SPAWN_POS,
    };
  },
  GRID: {
    get TILE_SIZE() { return SharedConstants.Grid.TILE_SIZE; }
  }
};
